/**
 * Alert and Notification type definitions
 */

export enum AlertType {
  STOCK_BELOW_MIN = 'stock_below_min',
  STOCKOUT = 'stockout',
  ORDER_PENDING = 'order_pending',
  FORECAST_ANOMALY = 'forecast_anomaly',
  EXPIRY_WARNING = 'expiry_warning',
  SLOW_MOVING = 'slow_moving',
  EXCESS_STOCK = 'excess_stock',
}

export enum AlertSeverity {
  INFO = 'info',
  WARNING = 'warning',
  CRITICAL = 'critical',
}

export enum AlertStatus {
  ACTIVE = 'active',
  ACKNOWLEDGED = 'acknowledged',
  RESOLVED = 'resolved',
  SUPPRESSED = 'suppressed',
}

export enum NotificationChannel {
  EMAIL = 'email',
  SMS = 'sms',
  IN_APP = 'in_app',
  SLACK = 'slack',
}

export interface Alert {
  alert_id: string;
  rule_id: string;
  alert_type: AlertType;
  severity: AlertSeverity;
  status: AlertStatus;
  title: string;
  message: string;
  entity_type?: string;
  entity_id?: string;
  store_id?: string;
  product_id?: string;
  alert_data?: Record<string, any>;
  triggered_at: string;
  acknowledged_at?: string;
  acknowledged_by?: string;
  resolved_at?: string;
  resolved_by?: string;
}

export interface AlertSummary {
  total_alerts: number;
  active_alerts: number;
  critical_count: number;
  warning_count: number;
  info_count: number;
  unread_notifications: number;
}

export interface Notification {
  notification_id: string;
  alert_id?: string;
  channel: NotificationChannel;
  subject?: string;
  message: string;
  sent_at?: string;
  read_at?: string;
  created_at: string;
}

export interface AlertRule {
  rule_id: string;
  rule_name: string;
  alert_type: AlertType;
  severity: AlertSeverity;
  conditions: Record<string, any>;
  is_active: boolean;
  evaluation_frequency: string;
  created_at: string;
  updated_at?: string;
}

export interface AlertRuleCreate {
  rule_name: string;
  alert_type: AlertType;
  severity: AlertSeverity;
  conditions: Record<string, any>;
  applies_to_stores?: string[];
  applies_to_products?: string[];
  applies_to_categories?: string[];
  notification_channels?: string[];
  notification_template?: string;
  is_active?: boolean;
  evaluation_frequency?: string;
  suppression_window?: number;
  escalation_minutes?: number;
  escalation_to_roles?: string[];
}

export interface UserNotificationPreferences {
  preference_id: string;
  user_id: string;
  email_enabled: boolean;
  email_address?: string;
  sms_enabled: boolean;
  phone_number?: string;
  in_app_enabled: boolean;
  slack_enabled: boolean;
  slack_webhook?: string;
  alert_preferences: Record<string, any>;
  quiet_hours_enabled: boolean;
  quiet_hours_start?: string;
  quiet_hours_end?: string;
  daily_digest_enabled: boolean;
  daily_digest_time?: string;
}

export interface UserNotificationPreferencesUpdate {
  email_enabled?: boolean;
  email_address?: string;
  sms_enabled?: boolean;
  phone_number?: string;
  in_app_enabled?: boolean;
  slack_enabled?: boolean;
  slack_webhook?: string;
  alert_preferences?: Record<string, any>;
  quiet_hours_enabled?: boolean;
  quiet_hours_start?: string;
  quiet_hours_end?: string;
  daily_digest_enabled?: boolean;
  daily_digest_time?: string;
}
